import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';

/**
 * @deprecated
 * This service will be removed
 * Do not add to it.
 */
@Injectable()
export class ApplicantTrackerService {
    private apiBaseUrl = '/v1/applicantTracker';

    constructor(private http: HttpClient) {}

    getReadyToHire(): Promise<any> {
        const endpoint = `${this.apiBaseUrl}/applicants/ready`;
        return this.http.get(endpoint).toPromise().then(this.returnJson).catch(this.throwError);
    }

    /*************************
     * Job Board
     *********************** */
    getBoardSettings(): Promise<any> {
        const endpoint = `${this.apiBaseUrl}/board`;
        return this.http.get(endpoint).toPromise().then(this.returnJson).catch(this.throwError);
    }

    saveBoardSettings(settings: any): Promise<any> {
        const endpoint = `${this.apiBaseUrl}/board`;
        return this.http.post(endpoint, settings).toPromise().then(this.returnJson).catch(this.throwError);
    }

    /*************************
     * Integrations
     *********************** */
    getIntegrations(): Promise<any> {
        const endpoint = `${this.apiBaseUrl}/integrations`;
        return this.http.get(endpoint).toPromise().then(this.returnJson).catch(this.throwError);
    }

    saveIntegration(data: any): Promise<any> {
        const endpoint = `${this.apiBaseUrl}/integrations`;
        return this.http.post(endpoint, data).toPromise().then(this.returnJson).catch(this.throwError);
    }

    /*************************
     * Callbacks
     *********************** */
    private returnJson(res: HttpResponse<any>) {
        try {
            return Promise.resolve(res);
        } catch (e) {
            console.error('Failed to parse the JSON response from the server', res);
            return Promise.reject(res);
        }
    }

    private throwError(error: any) {
        return Promise.reject(error);
    }
}
